import { render } from "./DreamBroker.vue?vue&type=template&id=70399314"
import script from "./DreamBroker.vue?vue&type=script&lang=js"
export * from "./DreamBroker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__